module.exports = __webpack_public_path__ + "static/media/ic_rubbe_inverted.812759d8.svg";